import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { getAppCfg, getPaymentRecuring, setPaymentRecuring } from "../../utils/common";
import { Grid, withStyles } from "@material-ui/core";
import Container from "../../components/Container";
import { ErrorIcon, SuccessIcon } from "../../components/icons";
import Typo from '../../components/CustomTypo';
import ModalAlert from "../../components/ModalAlert";
import { useHistory } from "react-router-dom";
import { paths } from "../../../portal.router.config";
import { payment } from "../../wsclient/crmservices/payment";
import crmservices from "../../wsclient/crmservices";
import ButtonCustom from "../../components/ButtonCustom";
import { airlinkservices } from "../../wsclient/crmservices/airlinkservices";
import { connection } from "../../../portal.config";

function ProcessPayment(props) {
    const { classes, t } = props;
    const [ready, setReady] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [isSuccess, setIsSuccess] = useState(false);
    const [integration, setIntegration] = useState(null);
    const [wallet, setWallet] = useState(null);
    const [account, setAccount] = useState(null);
    const [topupResult, setTopupResult] = useState(null);

    const paymentInfo = getPaymentRecuring();
    const navigate = useHistory();

    useEffect(() => {
        onLoad();
    }, [])

    useEffect(() => {
        if (integration && integration.id && wallet && wallet.id) {
            if (paymentInfo && paymentInfo.from == 'invoice') {
                onCreateTopup();
                // if (paymentInfo.is_one_time_payment) {
                    
                // } else if (account.balance > 0) {
                //     createPayment();
                // } else {
                //     setTopupResult({
                //         success: true,
                //         message: 'Top Up was created successfully.'
                //     })
                //     setReady(true);
                //     setIsSuccess(true)
                //     setPaymentRecuring({})
                // }
            } 
            // else if (paymentInfo && paymentInfo.from == 'invoice') {
            //     setTopupResult({
            //         success: true,
            //         message: 'Top Up was created successfully.'
            //     })
            //     setReady(true);
            //     setIsSuccess(true)
            //     setPaymentRecuring({})
            // }
            else {
                let error = 'Failed create toupup.'
                setTopupResult({
                    success: false,
                    message: error,
                })
                setReady(true);
                setIsSuccess(false)
            }
        }
    },[integration, wallet])

    const onLoad = async () => {
        onShowLoading(true);
        let searchStr = window.location.search;
        let token = paymentInfo && paymentInfo.token ? paymentInfo.token : '';
        if (token && searchStr && searchStr.search(token) > 0 && searchStr.includes('success')) {
            await getWalletInfo();
            await getIntegrations();
            // setReady(true);
            // setIsSuccess(true);
            // if (paymentInfo && paymentInfo.from == 'invoice') {
            //     setTimeout(() => {
            //         navigate.push(paths.invoice)
            //     }, 2000);
            // }
        }
        else {
            setReady(true);
            setIsSuccess(false);
        }
        // setPaymentRecuring({})
        onShowLoading(false);
    }

    const showMessage = (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }

    const createPayment = async () => {
        onShowLoading(true)
        try {
            let urlStr = window.location.search;
            let searchStr = urlStr.split('/');
            let client_secret = searchStr ? searchStr[searchStr.length - 1] : null;
            let _amountPayment = paymentInfo.amount;
            if (account && account.balance > 0 && account.balance < paymentInfo.amount) {
                _amountPayment = account.balance;
            }
            let result = await payment.createPayment({
                integration_id: integration.id,
                amount: _amountPayment ? Number(_amountPayment) : 0,
                account_id: account.id,
                client_secret: client_secret,
                payment_method: {
                    type: 'CRM_WALLET'
                },
                external_payable: [{
                    reference: new Date().getTime(),
                }],
                notes: 'Airlink Portal create payment',
            })
            console.log("AAAA createPayment result: ", result)
            if (result.code == 'OK') {
                setReady(true);
                setIsSuccess(true);
                // if (paymentInfo && paymentInfo.from == 'invoice') {
                //     setTimeout(() => {
                //         navigate.push(paths.invoice)
                //     }, 2000);
                // }
            } else {
                setReady(true);
                setIsSuccess(false);
            }
        } catch (error) {
            console.log("AAAA createPayment error: ", error)
        }
        setPaymentRecuring({});
        onShowLoading(false)
    }

    const getIntegrations = async () => {
        if (connection.crmConfig.isOpenStripe) {
            setIntegration({ id: connection.crmConfig.stripeIntegration })
            return;
        }
        try {
            let portalConfig = getAppCfg();
            let result = await payment.getIntegrations({
                connector: 'SOLIDGATE'
            }, portalConfig.id);
            console.log("AAAA getIntegrations result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) setIntegration(result.data.content[0])
            }
        } catch (error) {
            console.log("AAAA getIntegrations error: ", error)
        }
    }

    const getWalletInfo = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            if (result.code == 'OK') {
                setAccount(result.data);
                if (result.data && result.data.wallet) setWallet(result.data.wallet)
            }
        } catch (error) {
            console.log("AAAA getWalletInfor error: ", error)
        }
    }

    const onCreateTopup = async () => {
        onShowLoading(true)
        let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';        
        if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';
        try {
            let urlStr = window.location.search;
            let searchStr = urlStr.split('/');
            let client_secret = searchStr ? searchStr[searchStr.length - 1] : null;
            let paymentMethod = {}
            if (paymentInfo && paymentInfo.payment_method_id) {
                paymentMethod = {
                    type: 'CARD',
                    id: paymentInfo.payment_method_id
                }
            } else {
                paymentMethod = { type: 'ONE_TIME_CARD_PAYMENT' }
            }
            let custom_fields = [];
            if (paymentInfo && paymentInfo.topup_gateway) {
                custom_fields.push({
                    key: 'topup_gateway',
                    value: paymentInfo.topup_gateway,
                })
            }
            let result = await payment.createTopups({
                integration_id: integration.id,
                amount: paymentInfo && paymentInfo.amount,
                wallet_id: wallet && wallet.id,
                client_secret: client_secret,
                payment_method: paymentMethod,
                custom_fields: custom_fields,
            })
            console.log("AAAA createTopups result: ", result)
            if (result.code == 'OK') {
                if(account.balance > 0) await createPayment();
                else {
                    setTopupResult({
                        success: true,
                        message: 'Top Up was created successfully.'
                    })
                    setReady(true);
                    setIsSuccess(true)
                }
                setPaymentRecuring({})
            } else {
                let error = result.data && result.data.message ? result.data.message : 'Failed create toupup.'
                setTopupResult({
                    success: false,
                    message: error,
                })
                setReady(true);
                setIsSuccess(false)
            }
        } catch (error) {
            console.log("AAAA onCreateTopup error: ", error)
        }
        onShowLoading(false)
    }

    if(ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item justify='center' container>
                    <Grid xs={12} sm={12} md={8} lg={6} item>
                        <Grid xs={12} item justify='center' container style={{ marginTop: 16 }}>
                            {isSuccess == true && <SuccessIcon style={{ width: 100, height: 100 }} />}
                            {isSuccess == false && <ErrorIcon style={{ width: 100, height: 100 }} />}
                        </Grid>
                        {topupResult ? <>
                            <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                                <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{topupResult.message}</Typo>
                            </Grid>
                        </> : <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                            {isSuccess == true && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('PAYMENT_SUCCESS')}</Typo>}
                            {isSuccess == false && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('PAYMENT_FAILED')}</Typo>}
                        </Grid>}
                        <Grid item xs={12} justifyContent="center" container>
                            <ButtonCustom color={'primary'} onClick={() => navigate.push(paths.home)}>Back to Home</ButtonCustom>
                        </Grid>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return(
            <Container showLoading={showLoading}>
            </Container>
        )
    }    
}

const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
});

export default withStyles(styles)(withTranslation()(ProcessPayment));